import { render, staticRenderFns } from "./Subreddit.vue?vue&type=template&id=41f15747&"
import script from "./Subreddit.vue?vue&type=script&lang=js&"
export * from "./Subreddit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports